import { ARBITRUM, AVALANCHE, ETHEREUM, SHIBARIUM, GOERLI, PUPPY_NET, FANTOM, MUMBAI } from "./chains";

export const SUBGRAPH_URLS = {
  [ARBITRUM]: {
    stats: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-arbitrum-referrals",
    nissohVault: "https://api.thegraph.com/subgraphs/name/nissoh/gmx-vault",
  },

  [AVALANCHE]: {
    stats: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-avalanche-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/gmx-io/gmx-avalanche-referrals",
  },

  [ETHEREUM]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-referrals",
  },

  [SHIBARIUM]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-referrals",
  },

  [GOERLI]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-referrals",
  },

  [PUPPY_NET]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-referrals",
  },

  [FANTOM]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-referrals",
  },

  [MUMBAI]: {
    stats: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-stats",
    referrals: "https://api.thegraph.com/subgraphs/name/mummyfinance/fantom-referrals",
  },

  common: {
    chainLink: "https://api.thegraph.com/subgraphs/name/deividask/chainlink",
  },
};
